module.exports = __webpack_public_path__ + "static/34-66500c54779750abd40fd2970dd954e7.png";